import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import _ from "lodash";

import { URLS } from "config/urls";
import { handleInvalidRequest } from "utils/sdk";
import { addQueryParams, reverse } from "utils/urls";

import { fetchCompanyPackageWithTabsInformation } from "./sdk";

interface IDueDiligenceRerouteToTab {
  dealId: number;
  packageId: number;
  tabId: number | null;
}
export const useDueDiligenceRerouteToTab = ({
  dealId,
  packageId,
  tabId,
}: IDueDiligenceRerouteToTab) => {
  const [showError, setShowError] = useState(false);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const searchQueryParams = useMemo(() => {
    const queryParams: { [key: string]: string } = {};
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      queryParams[param] = value;
    }

    return queryParams;
  }, [searchParams]);

  useEffect(() => {
    if (_.isNil(tabId) && !_.isNil(packageId)) {
      fetchCompanyPackageWithTabsInformation({
        dealId,
        packageId,
      })
        .then(({ tabs }) => {
          if (tabs.length > 0) {
            const tabId = _.get(tabs, "[0].id");

            if (_.isUndefined(tabId)) {
              return;
            }

            navigate(
              addQueryParams(
                reverse(URLS.DEAL_PACKAGE, {
                  dealId,
                  packageId,
                  tabId,
                }),
                searchQueryParams
              )
            );
          } else {
            setShowError(true);
          }
        })
        .catch(handleInvalidRequest);
    }
  }, [dealId, packageId, tabId, searchQueryParams, navigate]);

  return { showError };
};
